import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-job_alert",
  "use": "icon-job_alert-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"icon-job_alert\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h26v26H0z\" /><path d=\"m13 1.083 8.902 1.979c.495.11.848.549.848 1.057v10.82a6.5 6.5 0 0 1-2.895 5.407L13 24.916l-6.855-4.57A6.497 6.497 0 0 1 3.25 14.94V4.12c0-.508.353-.947.848-1.057L13 1.083Zm-1.083 10.111H7.583v2.167h4.334v4.333h2.166v-4.333h4.334v-2.167h-4.334V6.861h-2.166v4.333Z\" fill=\"#FF6000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol